import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Profile = {
  id: string;
  email: string;
  full_name: string | null;
  location: string | null;
  timezone: string;
  created_at: string;
  updated_at: string;
};

export type WidgetConfig = {
  id: string;
  user_id: string;
  widget_type: string;
  position: number;
  size: string;
  is_enabled: boolean;
  settings: Record<string, unknown>;
  created_at: string;
  updated_at: string;
};

export type UserPreferences = {
  id: string;
  user_id: string;
  theme: 'light' | 'dark' | 'auto';
  default_view: string;
  refresh_interval: number;
  preferences: Record<string, unknown>;
  created_at: string;
  updated_at: string;
};

export type UserFavorite = {
  id: string;
  user_id: string;
  favorite_type: string;
  favorite_value: string;
  metadata: Record<string, unknown>;
  created_at: string;
};
